import axios from "axios";

/** True when a request was denied with HTTP 403. */
export function isPermissionError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 403;
}
